import { create } from 'zustand';

export enum SidebarLeftTab {
  INHOUD = 'inhoud',
  FILTER = 'filter',
}

const useViewerStore = create<{
  showAllMeta: boolean;
  setShowAllMeta: (showAllMeta: boolean) => void;
  sidebarLeftTabId: SidebarLeftTab;
  setSidebarLeftTabId: (tabId: SidebarLeftTab) => void;
  scrollToParagraaf?: (id: string) => void;
  setScrollToParagraaf: (fn: ((id: string) => void) | null) => void;
}>()((set) => ({
  showAllMeta: false,
  setShowAllMeta: (showAllMeta) => set({ showAllMeta }),
  sidebarLeftTabId: SidebarLeftTab.INHOUD,
  setSidebarLeftTabId: (sidebarLeftTabId) => set({ sidebarLeftTabId }),
  scrollToParagraaf: undefined,
  setScrollToParagraaf: (scrollToParagraaf) =>
    set({ scrollToParagraaf: scrollToParagraaf ?? undefined }),
}));

export default useViewerStore;
